import { Form } from "react-bootstrap";

export default function EmailInput({ label, placeholder, value, required, onChange, onPaste, style, help, id, moreInfo, testId }) {
    return (
        <>
            {label && <Form.Label htmlFor={id} title={help ?? ""} style={help ? { cursor: 'help' } : {}}>{label}</Form.Label>}
            {moreInfo && <p className="more-info">{moreInfo}</p>}
            <Form.Control
                // className="text-input"
                id={id}
                value={value}
                onChange={onChange}
                onPaste={onPaste}
                placeholder={placeholder}
                style={style}
                type="email"
                required={required}
                data-testid={testId}
            />
        </>
    )
}